import React, { Fragment } from 'react';
import { func } from 'prop-types';
import { Query } from 'react-apollo';
import ErrorBoundary from 'components/ErrorBoundary';
import { GET_USER_RECIPE_TAGS } from 'graphql/recipebox';

/**
 *
 * Get User Recipe Tags query used for listing User Tags on the Recipe Box
 */
function GetUserRecipeTags(props) {
  const { children } = props;

  // Save errors on the client and catch on the server
  const errorPolicy = process.browser ? 'all' : 'none';

  return (
    <ErrorBoundary>
      <Query query={GET_USER_RECIPE_TAGS} errorPolicy={errorPolicy} ssr={false}>
        {({ data: queryData, loading: queryLoading, error: queryError }) => (
          <Fragment>
            {children({
              data: queryData,
              error: queryError,
              loading: queryLoading
            })}
          </Fragment>
        )}
      </Query>
    </ErrorBoundary>
  );
}

GetUserRecipeTags.propTypes = {
  children: func.isRequired
};

export default GetUserRecipeTags;
